<script>
  // How many emails the server has sent this month and today, and which kinds use them. Counted per recipient.
  import { onMount } from 'svelte';
  import Card from '../ui/Card.svelte';

  const LABELS = {
    OrderUpdate: 'Customer order updates', OrderNotification: 'New-order emails to you', Newsletter: 'Newsletter', ConfirmSubscription: 'Subscription confirmations',
    WeeklySummary: 'Weekly summary', NewDeviceAlert: 'Sign-in alerts', SystemAlert: 'Site alerts', DropDigest: 'Drop reminders', TestEmail: 'Test emails', other: 'Other',
  };
  let usage = $state(null);
  let failed = $state(false);
  onMount(async () => {
    try { const r = await fetch('/api/admin/email-usage', { credentials: 'include' }); if (!r.ok) throw new Error(); usage = await r.json(); }
    catch { failed = true; }
  });
  const max = $derived(usage ? Math.max(1, ...usage.kinds.map(k => k.count)) : 1);
</script>

<Card title="Email use" description="Emails sent by the server this month. Each recipient counts as one.">
  <div class="space-y-4 p-6 pt-4">
    {#if failed}
      <p class="text-sm text-muted-foreground">Could not load email use.</p>
    {:else if !usage}
      <p class="text-sm text-muted-foreground" role="status">Loading…</p>
    {:else}
      <div class="flex gap-8">
        <div><p class="text-2xl font-semibold tabular-nums">{usage.total}</p><p class="text-sm text-muted-foreground">this month</p></div>
        <div><p class="text-2xl font-semibold tabular-nums">{usage.today}</p><p class="text-sm text-muted-foreground">today</p></div>
      </div>
      {#if usage.kinds.length}
        <ul class="space-y-2">
          {#each usage.kinds as k (k.kind)}
            <li class="text-sm">
              <div class="flex justify-between gap-4"><span>{LABELS[k.kind] || k.kind}</span><span class="tabular-nums text-muted-foreground">{k.count}</span></div>
              <div class="mt-1 h-1.5 overflow-hidden rounded-full bg-muted"><div class="h-full rounded-full bg-foreground/70" style="width:{(k.count / max) * 100}%"></div></div>
            </li>
          {/each}
        </ul>
      {:else}
        <p class="text-sm text-muted-foreground">No emails sent yet this month.</p>
      {/if}
      <p class="text-xs text-muted-foreground">Order alerts go to your devices as free notifications. Customer update emails can be switched off one by one in Settings.</p>
    {/if}
  </div>
</Card>
